import React from 'react';
import { toInteger } from 'lodash';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';
import { PAGE_DIRECTORY } from '../../../services/filter/constants';

import { filterPartnerOnCategory } from '../../../services/filter/actions';

import { formatCategoryNameForUrl } from '../../../services/category/utils';

import DirectoryPage from './DirectoryPage';
import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';
import { CategoryDirectoryTemplate } from '../../template/CategoryDirectoryTemplate';

export class CategoryDirectoryPage extends React.Component {
    componentDidMount() {
        const { match } = this.props;
        const categoryId = Number(match.params.categoryId);
        if (categoryId) {
            this.props.filterPartnerOnCategory(PAGE_DIRECTORY, categoryId);
        }
    }

    render() {
        const { match, isCodePromo = false, category, Breadcrumb, i18nDirectoryPage } = this.props;
        const isOffline = match.params.type === PATH.OFFLINE;
        const isEbon = match.params.type === PATH.EBON;

        return (
            <div>
                <HeadComponent
                    title={category.label}
                    description={category.label}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.CASHBACK_PATH}/${match.params.type}/${
                        PATH.CATEGORY_PATH
                    }/${formatCategoryNameForUrl(category.label)}-${category.id}`}
                />
                <LocalizedBreadcrumbItem to={`${PATH.CASHBACK_PATH}/${match.params.type}`}>
                    {isOffline
                        ? i18nDirectoryPage.OFFLINE_TITLE
                        : isEbon
                        ? i18nDirectoryPage.EBON_TITLE
                        : i18nDirectoryPage.ONLINE_TITLE}
                </LocalizedBreadcrumbItem>
                <LocalizedBreadcrumbItem to={match.url}>{category.label}</LocalizedBreadcrumbItem>
                <DirectoryPage
                    categoryId={category && category.id ? toInteger(category.id) : -1}
                    isCodePromo={isCodePromo}
                    Breadcrumb={Breadcrumb}
                    isOffline={isOffline}
                    isEbon={isEbon}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        i18nDirectoryPage: state.i18n.page.DIRECTORY.MOST_POPULAR,
        category: state.category.categories[ownProps.match.params.categoryId] || {}
    };
};

const mapDispatchToProps = {
    filterPartnerOnCategory
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(CategoryDirectoryPage),
    CategoryDirectoryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/directory/CategoryDirectoryPage.js